import { httpGet } from "../api/chatHttp";
import { Message, MessageDataPayload } from "../../data/chat";

async function getMessagesAction(onSuccess: (messages: Message[]) => void, onError: (msg: string) => void): Promise<AdminMessage[] | null> {
  try {
    const data: Message[] = await httpGet<Message[]>('/api/GetMessageHistory/');

    const sortData = data.sort((messageA: Message, messageB: Message) => {
      return messageA.CreatedAt.valueOf() <= messageB.CreatedAt.valueOf() ? (messageA.CreatedAt.valueOf() == messageB.CreatedAt.valueOf() ? 0 : -1) : 1
    })
    onSuccess(sortData);
    return sortData;
  } catch (e) {
    onError((e as Error).message)
    return null;
  }
}
export {getMessagesAction}